<template>
  <div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  components: {},
  methods: {
    loadCity () {
      try {
        this.$axios.get('site/list').then((res) => {
          if (res.data.code == 200) {
            this.$store.commit('SET_ALLSITE', JSON.stringify(res.data.data))
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    loadInfo () {
      try {
        this.$axios.get('user/info').then((res) => {
          if (res.data.code == 200) {
            this.$store.commit('SetInfo', JSON.stringify(res.data.data))
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
  created () {
    let token = '82efc41c9a2911e9e9d61bdb61843cb58180439d'
    console.log(token)
    this.$store.commit('SET_TOKEN', token)
    this.loadCity()
    this.loadInfo()
    this.$router.push({ path: './' })
  },
}
</script>